import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/fromEvent';
import "rxjs/add/operator/debounceTime";
import { Subject } from 'rxjs/Subject';
import { Question } from '../../Models/dennysFlow';

@Component({
  selector: 'app-dynamic-input',
  templateUrl: './dynamic-input.component.html',
  styleUrls: ['./dynamic-input.component.less']
})
export class DynamicInputComponent implements AfterViewInit {
  
  @Input() model : Question;
  @Input() for : string;
  @Input() text : string;
  @Input() type : string;
  @Output() updated = new EventEmitter<string>();
  public glow:boolean = true;
  constructor() {
  }

  update(res: any){
    //set the answer on its question
    this.model.Set(this.model.Answer);
    this.updated.emit('value change');
  }

  ngAfterViewInit(): void {
    var inpt = document.getElementById(this.for);
    let keyPress$ = Observable
      .fromEvent(inpt,'input')
      .debounceTime(500)
      .subscribe(res => this.update(res));
    // this.model.Answer = this.model.Get();
    // this.glow= this.model.show();
    
    // inpt.focus();
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/git/SynergiPartners 7-Eleven Screening/src/app/utility-components/dynamic-input/dynamic-input.component.ts